import React from 'react';
import { Layout } from 'antd';
import { ReactComponent as EuropeanUnionLogo } from 'assets/icons/european_union.svg';
import { ReactComponent as GreeceGovernmentLogo } from 'assets/icons/government-greece-logo2.svg';
import { ReactComponent as GreenMinistryLogo } from 'assets/icons/green_ministry_gov.svg';
import { useLocation } from 'react-router-dom';

const { Content } = Layout;

const Footer = () => {
  const location = useLocation();
  const isStaticPage = location.pathname === '/';
  return (
    !isStaticPage && (
      // <div id="footer-container" className="footer-container">
      //   <div className="footer-background"></div>
      //   <div id="footer-content" className='main-container'>
      //     <GreenMinistryLogo className="digital_logo" />
      //   </div>
      //   <div className="footer-logo">
      //     <EuropeanUnionLogo className="digital_logo" />
      //   </div>
      //   <div className="footer-logo">
      //     <GreeceGovernmentLogo className="digital_logo" />
      //   </div>
      // </div>
      <div className="footer-container">
        <div className="footer-background" />
        <div className="footer-content">
          <div className="footer-logo">
            <GreenMinistryLogo />
          </div>
          <div className="footer-logo">
            <EuropeanUnionLogo />
          </div>
          <div className="footer-logo">
            <GreeceGovernmentLogo />
          </div>
        </div>
      </div>
    )
  );
};

export default Footer;
